const data = {
  id: 1,
  title: 'Listen and tick T or F.',
  subTitle: 'Nghe và chọn đúng hoặc sai.',
  audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/1dc6dbb1-b89a-41d5-82ba-8a5ea80e3e7b.mp3',
  imageUrl: '',
  questionText: '',
  question: '',
  answers: [
    { answer: 'An is going to Nha Trang Beach this summer holiday.', isCorrect: false },
    { answer: 'An is going to visit her grandparents this summer holiday.', isCorrect: true },
    { answer: 'Binh is going to Nha Trang Beach this summer holiday.', isCorrect: true },
  ],

};

export default data;
